import { render, staticRenderFns } from "./LeftView.vue?vue&type=template&id=bdd751c4"
import script from "./LeftView.vue?vue&type=script&lang=js"
export * from "./LeftView.vue?vue&type=script&lang=js"
import style0 from "./LeftView.vue?vue&type=style&index=0&id=bdd751c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports